import MyHeader from "./MyHeader.js";
import ProjectContainer from "./ProjectContainer.js";
import ExperienceContainer from "./ExperienceContainer.js";


const Main = () =>{
    return <div className="wrapper">
      <MyHeader />
  <ProjectContainer/>
<ExperienceContainer/>
    </div>
}
export default Main;